import * as ReactDOM from "react-dom/client";
import "./app.scss";
import "bbr-basemap/style.css";
import App from "./App";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);
